<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span jhiTranslate="germplasm-grouping.title"></span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="close()">
    </button>
</div>
<div class="modal-body">
    <div class="table-responsive" style="max-height: 600px; overflow: scroll;">
        <table class="table table-striped table-bordered table-curved table-fixed">
            <thead>
            <tr>
                <th scope="col" style="width: 15%" jhiTranslate="germplasm-grouping.column.gid">GID</th>
                <th scope="col" style="width: 15%" jhiTranslate="germplasm-grouping.column.mgid">Group ID (MGID)</th>
                <th scope="col" style="width: 10%" jhiTranslate="germplasm-grouping.column.total.members">Total Members</th>
                <th scope="col" style="width: 30%" jhiTranslate="germplasm-grouping.column.group.members">Group Members</th>
                <th scope="col" style="width: 25%" jhiTranslate="germplasm-grouping.column.notes">Notes</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let groupResult of results">
                <td>{{groupResult.founderGid}}</td>
                <td>{{groupResult.groupId}}</td>
                <td>{{groupResult.groupMembers.length}}</td>
                <td class="col word-wrap">
                    <truncate-span [textInput]="displayMembers(groupResult.groupMembers)" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                </td>
                <td *ngIf="groupResult.generative">
                    <span jhiTranslate="germplasm-grouping.grouping-result-generative"></span>
                </td>
                <td *ngIf="!groupResult.generative">
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="close()" data-test="confirmGroupButton">
        <span jhiTranslate="ok">OK</span>
    </button>
</div>
